import * as React from 'react'
import Linkify from 'react-linkify'
import ReactMarkdown from 'react-markdown'
import { openUrl } from './routeHelpers'

export const formatDescriptionMarkdown = (description: string) => (
  <ReactMarkdown
    components={{
      a: ({ href, children }) => (
        <a
          href={undefined}
          onClick={() => href && openUrl(href, true)}
          style={{ textDecoration: 'underline', cursor: 'pointer' }}
        >
          {children}
        </a>
      ),
    }}
  >
    {description}
  </ReactMarkdown>
)

export const formatDescription = (description: string) => (
  <Linkify
    componentDecorator={(decoratedHref, decoratedText, key) => (
      <a
        key={key}
        href={undefined}
        onClick={() => openUrl(decoratedHref, true)}
        style={{ textDecoration: 'underline', cursor: 'pointer' }}
      >
        {decoratedText}
      </a>
    )}
  >
    {description}
  </Linkify>
)

export function formatNullValues(value: number | null): number {
  return value === null ? 0 : value
}
